<template>
  <div class="agents_wrap">
    <div class="toolbar">
      <el-form :inline="true" :model="queryForm" class="query_form">
        <el-form-item label="名称">
          <el-input v-model="queryForm.name" placeholder="名称模糊搜索" clearable
                    style="width: 180px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" placeholder="全部" clearable style="width: 120px">
            <el-option label="启用" value="active" />
            <el-option label="已归档" value="archived" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button v-if="canWrite" type="primary" icon="el-icon-plus" @click="openAdd">新增数字员工</el-button>
    </div>

    <el-table :data="tableData" v-loading="loading" border :empty-text="emptyText">
      <el-table-column label="展示名" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.display_name || scope.row.name }}</template>
      </el-table-column>
      <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
            {{ scope.row.status === 'active' ? '启用' : '已归档' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.description || '-' }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="canWrite" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="goSessions(scope.row)">查看会话</el-button>
          <el-button v-if="canWrite" type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <el-dialog :title="isEdit ? '编辑数字员工' : '新增数字员工'" :visible.sync="dialogVisible"
               width="560px" v-dialogDrag :modal-append-to-body="false" v-if="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" maxlength="64" placeholder="同企业下唯一" />
        </el-form-item>
        <el-form-item label="展示名">
          <el-input v-model="form.display_name" maxlength="64" placeholder="默认同名称" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" :rows="2" maxlength="200" />
        </el-form-item>
        <el-form-item label="角色画像">
          <el-input v-model="form.persona" type="textarea" :rows="4" maxlength="2000"
                    placeholder="系统提示词，定义数字员工的身份与职责" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="active">启用</el-radio>
            <el-radio label="archived">已归档</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="isEdit" label="模型配置">
          <el-select v-model="form.model_config_id" clearable filterable
                     placeholder="未配置（使用默认模型）" style="width: 100%">
            <el-option v-for="m in modelOptions" :key="m.config_id"
                       :label="(m.name || m.config_id) + (m.chat_model ? '（' + m.chat_model + '）' : '')"
                       :value="m.config_id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isAdminAcc, isEnterprise } from '../utils'

// 数字员工管理：企业（acctype=2）完整 CRUD；个人（acctype=1）只读列表
export default {
  name: 'AiAgentAgents',
  data() {
    return {
      canWrite: isEnterprise(),
      isPersonal: localStorage.getItem('acctype') === '1',
      queryForm: { name: '', status: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      dialogVisible: false,
      isEdit: false,
      submiting: false,
      form: this.emptyForm(),
      modelOptions: [],
      modelOptsLoaded: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    emptyText() {
      return this.isPersonal ? '暂无数字员工，请联系企业管理员开通' : '暂无数据'
    }
  },
  mounted() {
    // 管理员无 owner，常驻挂载下发 owner 型请求会 1002 弹错，跳过自动加载
    if (isAdminAcc()) return
    this.onSubmit()
  },
  methods: {
    emptyForm() {
      return { name: '', display_name: '', description: '', persona: '', status: 'active' }
    },
    onSubmit() {
      this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.name) data.name = this.queryForm.name
      if (this.queryForm.status) data.status = this.queryForm.status
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList, agentBody(data)).then((res) => {
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
        this.loading = false
      }).catch(() => { this.loading = false }) // 拦截器已对 code!==0 统一弹错，这里只复位
    },
    onSearch() {
      this.currentPage = 1
      this.onSubmit()
    },
    resetQuery() {
      this.queryForm = { name: '', status: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.onSubmit() },
    handleCurrentChange(val) { this.currentPage = val; this.onSubmit() },
    openAdd() {
      this.form = this.emptyForm()
      this.isEdit = false
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    // edit 是全量覆盖语义（未传字段以零值覆盖），必须先 get 回填完整对象再整体提交
    openEdit(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsGet,
        agentBody({ agent_id: row.agent_id })).then((res) => {
        if (res.data.code != 0) return
        this.form = { ...res.data.data } // 完整对象落表单（含 metadata/model_config_id）
        this.isEdit = true
        this.dialogVisible = true
        this.loadModelOpts()
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      }).catch(() => {})
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submiting = true
        // 编辑：整体提交回填的完整 form；agent_id/owner_*/ctime/deleted 由服务端白名单保护，无需剔除
        // 新增：仅提交表单白名单字段
        const payload = this.isEdit
          ? { ...this.form }
          : { name: this.form.name, display_name: this.form.display_name,
              description: this.form.description, persona: this.form.persona, status: this.form.status }
        const url = this.isEdit ? this.$baseUrl.aiAgentAgentsEdit : this.$baseUrl.aiAgentAgentsAdd
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '操作成功' })
            this.dialogVisible = false
            if (!this.isEdit) this.currentPage = 1
            this.onSubmit()
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          // 拦截器仅对业务码弹错，HTTP/网络层失败无提示，这里兜底
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后不可恢复，确认删除该数字员工？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsDel,
          agentBody({ agent_id: row.agent_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.onSubmit()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    goSessions(row) {
      this.$emit('view-sessions', row.agent_id)
    },
    // P4：模型配置下拉数据源（编辑弹窗打开时懒加载一次，api_key 为掩码串仅作展示）
    loadModelOpts() {
      if (this.modelOptsLoaded) return
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsConfigList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) {
          this.modelOptions = res.data.data.data || []
          this.modelOptsLoaded = true
        }
      }).catch(() => {})
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 表单下边距改由 toolbar 承担，保证表格前的间距不变
  margin-bottom: 22px;
  // el-form-item 默认 22px 下边距会把表单撑到 62px，比右侧按钮(40px)高，
  // 「+ 新增数字员工」就落不到「查询/重置」那一行；清零后两者同为 40px，居中即对齐
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
.danger_text {
  color: #f56c6c;
}
</style>
